module.exports = __webpack_public_path__ + "09031f99b39a6f9918b03f0c15fc1fe0.png";